package com.essntl.features.file.ui.essntlgallery

import com.essntl.features.file.domain.model.FileModel

sealed interface EssntlGalleryEvent {
    data class GetAllImages(val entityType: String) : EssntlGalleryEvent
    data class AddImages(val files: List<FileModel>) : EssntlGalleryEvent
    data class SwitchTab(
        val index: Int = 0,
        val dialog: Boolean = false,
    ) : EssntlGalleryEvent

    data class DeleteImage(val id: String) : EssntlGalleryEvent
    data class UpdateImage(val file: FileModel) : EssntlGalleryEvent
}